<template>
  <bd-dialog :title="title" v-model:model-value="visible" :width="width" append-to-body>
    {{ desc }}
    <template v-slot:footer>
      <span class="dialog-footer">
        <bd-button size="large" @click="onCancel">{{ cancelText }}</bd-button>
        <bd-button size="large" type="primary" @click="onConfirm">{{ confirmText }}</bd-button>
      </span>
    </template>
  </bd-dialog>
</template>

<script>
export default {
  emits: ['update:modelValue', 'confirm', 'cancel'],
  props: {
    modelValue: Boolean,
    width: {
      type: String,
      default: '340px'
    },
    title: String,
    cancelText: {
      type: String,
      default: '取消离开'
    },
    confirmText: {
      type: String,
      default: '确认离开'
    },
    desc: String,
    center: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    visible: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('update:modelValue', val)
        return val
      }
    }
  },
  methods: {
    onConfirm() {
      this.$emit('confirm')
      this.visible = false
    },
    onCancel() {
      this.$emit('cancel')
      this.visible = false
    }
  }
}
</script>
